import { Helmet } from "react-helmet";
import { useLandingPv } from "./landing-pv.hook";
import { PvSection1 } from "./sections/section1/landing-pv-section1";
import { PvSection2 } from "./sections/section2/landing-pv-section2";
import { PvSection3 } from "./sections/section3/landing-pv-section3";
import { PvSection5 } from "./sections/section5/landing-pv-section5";
import { PvSection4 } from "./sections/section4/landing-pv-section4";
import { Navigate } from "react-router-dom";
import { MAX_WIDTH } from "src/config";

export const LandingPV = () => {
  const { hasProducts, navigateToProductPageString, t } = useLandingPv();

  if (hasProducts) return <Navigate to={navigateToProductPageString} />;

  return (
    <div className="d-flex justify-content-center">
      <div className="bg-f5f5f5" style={{ maxWidth: MAX_WIDTH }}>
        <Helmet>
          <title>{t("meta.landing.title")}</title>
          <meta name="description" content={t("meta.landing.description")} />
        </Helmet>
        <div>
          <PvSection1 />
        </div>
        <div className="landing-pv-section-container">
          <PvSection2 />
        </div>
        <div className="landing-pv-section-container">
          <PvSection3 />
        </div>
        <div className="landing-pv-section-container">
          <PvSection4 />
        </div>
        <div className="landing-pv-section-container p-0">
          <PvSection5 />
        </div>
      </div>
    </div>
  );
};
